import React from "react"

const Tab = ({ tab, setTab, tabs = [] }) => {
  return (
    <div
      style={{
        display: "flex",
        gap: "10px",
        justifyContent: "center",
        marginBottom: "10px"
      }}
    >
      {tabs.map((item) => {
        return (
          <button
            onClick={() => setTab(item)}
            style={{
              padding: "6px",
              //   border: "none",
              borderRadius: "6px",
              ...(tab === item && {
                background: "#3498db",
                color: "#fff"
              })
            }}
          >
            {item}
          </button>
        )
      })}
    </div>
  )
}

export default Tab
